module.exports = __webpack_public_path__ + "img/temperature-three-quarters.1adcdf56.svg";